import { formatAsUriParameters, getResourceFromCms } from '@namespace/helpers';
// ts should import ts without js because of declarations
import { validateScheme } from '@namespace/helpers/src/utils/validateSchema';
import {
  SnippetsOptions,
  SnippetsParams,
  SnippetsParamsSchema,
  SnippetsResponse,
  SnippetsResponseSchema
} from './types';

const getSnippets = async (
  params: SnippetsParams,
  options: SnippetsOptions
): Promise<SnippetsResponse> => {
  validateScheme(SnippetsParamsSchema, params, { name: 'getSnippets' });

  const { ids, lang } = params;

  const formattedParams = formatAsUriParameters(
    {
      snippetIds: ids,
      lang
    },
    true
  );

  const pathPortion = `/snippets${
    formattedParams ? `?${formattedParams}` : ''
  }`;

  const getResourceOptions = {
    isSSR: options.isSSR,
    headers: options.headers,
    logger: options.logger
  };

  const res = await getResourceFromCms<SnippetsResponse>(
    pathPortion,
    getResourceOptions
  );

  validateScheme(SnippetsResponseSchema, res);

  return res;
};

export default getSnippets;
